<template>
  <div class="popup_in">
    <div class="popup">
      <img
        style="width:42px;margin-bottom:10px"
        src="/assets/img/svg/alert.svg"
      />
      <h2 class="title title--40">
        {{ title }}
        <br />
      </h2>
      <div class="flex flex--content--center">
        <a class="bt_blue" @click.prevent="$emit('close')">סגור</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "התרחשה שגיאה אנא רענן את המסך"
    }
  }
};
</script>

<style scoped></style>
